import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Search } from 'lucide-react';

interface ClassTemplatesFilterProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  courseTypeFilter: string;
  onCourseTypeChange: (value: string) => void;
  classTypeFilter: string;
  onClassTypeChange: (value: string) => void;
  statusFilter: string;
  onStatusChange: (value: string) => void;
}

export function ClassTemplatesFilter({
  searchQuery,
  onSearchChange,
  courseTypeFilter,
  onCourseTypeChange,
  classTypeFilter,
  onClassTypeChange,
  statusFilter,
  onStatusChange,
}: ClassTemplatesFilterProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-3">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="ค้นหา ครู, วิชา, นักเรียน, สถานที่..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9"
        />
      </div>
      
      <Select value={courseTypeFilter} onValueChange={onCourseTypeChange}>
        <SelectTrigger className="w-full sm:w-[160px]">
          <SelectValue placeholder="ประเภทหลักสูตร" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">ทุกหลักสูตร</SelectItem>
          <SelectItem value="REGULAR">REGULAR</SelectItem>
          <SelectItem value="INTER">INTER</SelectItem>
        </SelectContent>
      </Select>

      <Select value={classTypeFilter} onValueChange={onClassTypeChange}>
        <SelectTrigger className="w-full sm:w-[140px]">
          <SelectValue placeholder="ประเภทคลาส" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">ทุกประเภท</SelectItem>
          <SelectItem value="PREMIER">PREMIER</SelectItem>
          <SelectItem value="PRIVATE">PRIVATE</SelectItem>
        </SelectContent>
      </Select>

      <Select value={statusFilter} onValueChange={onStatusChange}>
        <SelectTrigger className="w-full sm:w-[130px]">
          <SelectValue placeholder="สถานะ" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">ทุกสถานะ</SelectItem>
          <SelectItem value="active">เปิดใช้งาน</SelectItem>
          <SelectItem value="inactive">ปิดใช้งาน</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
